import styled from "styled-components";
import { Button } from "@mui/material";

import { Close } from "@/assets/icons";

export const StyledGroup = styled.div`
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    flex: 100%;
`;

export const StyledGroupField = styled.div<{ $hide: boolean }>`
    flex: 100%;
    display: flex;
    align-items: start;
    flex-wrap: wrap;
    column-gap: 10px;

    ${({ $hide }) =>
        $hide &&
        `
        display: none;
    `}
`;
export const StyledCloseIcon = styled(Close)`
    cursor: pointer;
    margin-top: 8px;
    path {
        fill: var(--color-secondary);
    }
`;

export const StyledButtonCancel = styled(Button)`
    font-size: var(--size-14);
    text-transform: capitalize;
    margin-right: 10px;
    padding: 3px 8px;
    border: 1px solid var(--color-grey-700);

    &:hover {
        padding: 3px 7px;
    }
`;

export const StyledButtonSave = styled(Button)`
    font-size: var(--size-14);
    text-transform: capitalize;
    padding: 3px 8px;
`;
